<div class="not-found-container">
  <!-- Left Blue Curved Banner -->
  <div class="banner-section">
    <div class="content-wrapper">
      <h1 class="title">
       {{ text.title }}
        <span class="sub-title">404 Error</span>
      </h1>
      <p class="description">
        {{ text.description }}
      </p>
      <button class="btn-return" (click)="goHome()">
        {{ text.homeButton }}
      </button>
    </div>
  </div>

  <!-- Right Illustration Area -->
  <div class="illustration-section" aria-hidden="true">
    <div class="illustration-box">
      <!-- Minimalist Chest / Map Line-art SVG -->
      <svg class="illustration-svg" viewBox="0 0 240 200" fill="none" xmlns="http://www.w3.org/2000/svg">
        <!-- Chest Lid -->
        <path d="M60 70 C60 45, 180 45, 180 70 L180 90 L60 90 Z" stroke="#0046cd" stroke-width="3" stroke-linejoin="round" fill="none" />
        <path d="M60 70 L180 70" stroke="#0046cd" stroke-width="2" />
        
        <!-- Chest Base -->
        <path d="M60 90 L60 150 C60 155, 65 160, 70 160 L170 160 C175 160, 180 155, 180 150 L180 90 Z" stroke="#0046cd" stroke-width="3" stroke-linejoin="round" fill="none" />
        <path d="M80 90 L80 160" stroke="#0046cd" stroke-width="2" />
        <path d="M160 90 L160 160" stroke="#0046cd" stroke-width="2" />
        
        <!-- Lock -->
        <rect x="113" y="100" width="14" height="18" rx="2" stroke="#0046cd" stroke-width="2.5" fill="#f4f7ff" />
        <circle cx="120" cy="107" r="2" fill="#0046cd" />

        <!-- Question Key inside -->
        <path d="M120 78 C116 78, 114 74, 117 70 C120 66, 124 70, 120 74 L120 82" stroke="#0046cd" stroke-width="2.5" stroke-linecap="round" fill="none" />

        <!-- Map element -->
        <path d="M20 150 L50 135 L80 150 L50 165 Z" stroke="#0046cd" stroke-width="2" stroke-linejoin="round" fill="none" />
        <path d="M35 142 L65 157" stroke="#0046cd" stroke-width="1.5" stroke-dasharray="3 3" />
        <text x="38" y="140" font-size="10" font-weight="bold" fill="#0046cd">X</text>

        <!-- Seal Badge -->
        <circle cx="185" cy="40" r="16" stroke="#0046cd" stroke-width="2" fill="none" />
        <circle cx="185" cy="40" r="13" stroke="#0046cd" stroke-width="1" stroke-dasharray="2 2" fill="none" />
        <text x="181" y="45" font-size="14" font-weight="bold" fill="#0046cd">?</text>
      </svg>
    </div>
  </div>
</div>